// src/hooks/useOrganoidStatus.js
import { useEffect, useRef } from 'react';
import { authFetch } from '../utils/authFetch';

export function useOrganoidStatus(
  selectedOrganoid, 
  setStatus, 
  setPhase, 
  setRemainingSeconds, 
  setPhaseDuration, 
  setIsRecording, 
  uiState, 
  setUiState,
  setDrugTimestamp
) {
  const statusIntervalRef = useRef(null);     // tracks status polling interval
  const countdownIntervalRef = useRef(null);  // tracks countdown interval

  useEffect(() => {
    if (!selectedOrganoid || uiState !== 'running') return;    
    // Poll organoid status
    const pollStatus = async () => {
      try {
        const res = await authFetch(`${process.env.REACT_APP_API_URL}/status/${selectedOrganoid}`)
            if (!res.ok) {
              const errorText = await res.text();
              console.error(`Status fetch failed (${res.status}):`, errorText);
              return;
            }

            const json = await res.json();
            if (!json) return;

            setStatus(json.state);
            setPhase(json.phase);
            setRemainingSeconds(json.remaining_seconds);
            setPhaseDuration(json.phase_duration);
            setIsRecording(json.active); // Stop polling and reset UI if protocol is complete. always reflects backend-confirmed state

            console.log("isRecording (from backend):", json.active);

            if (!json.active) {
              //clearInterval(statusIntervalRef.current); // stop polling
              //statusIntervalRef.current = null;
              stopPolling();
              console.log("Protocol complete — recording stopped.");
              setUiState('complete');
              // Optional: reset other UI state here
            }

            if (json.drugTimestamp) {
              setDrugTimestamp(json.drugTimestamp);
            }


      } catch (err) {
        console.error('Error fetching status:', err);
      }
    };

    //statusIntervalRef.current = setInterval(pollStatus, 1000);

    const startPolling = () => {
      if (!statusIntervalRef.current) {
        statusIntervalRef.current = setInterval(pollStatus, 1000);
        console.log('[STATUS] Polling started');
      }
    };

    const stopPolling = () => {
      if (statusIntervalRef.current) {
        clearInterval(statusIntervalRef.current);
        statusIntervalRef.current = null;
        console.log('[STATUS] Polling stopped');
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log('[VISIBILITY] Tab visible — resuming status polling');
        startPolling();
      } else {
        console.log('[VISIBILITY] Tab hidden — pausing status polling');
        stopPolling();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    startPolling();

    return () => {
      stopPolling();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [selectedOrganoid, uiState]);

/*
    return () => {
      if (statusIntervalRef.current) {
        clearInterval(statusIntervalRef.current);
        statusIntervalRef.current = null;
      }
    };


  }, [selectedOrganoid, uiState]);
*/

  useEffect(() => {
    if (uiState !== 'running') return;

    countdownIntervalRef.current = setInterval(() => {
      setRemainingSeconds(prev => Math.max(prev - 1, 0));
    }, 1000);

    return () => {
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
        countdownIntervalRef.current = null;
      }
    };
  } , [uiState, selectedOrganoid]);

  function resetStatusState() {
    // Stop status polling
    if (statusIntervalRef.current) {
      clearInterval(statusIntervalRef.current);
      statusIntervalRef.current = null;
    }

    // Stop countdown timer
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }

    // Reset all externally controlled state
    setStatus(null);
    setPhase(null);
    setRemainingSeconds(null);
    setPhaseDuration(null);
    setIsRecording(false);
    setDrugTimestamp(null);
  }

  return { resetStatusState };

}